<template>
  <ModalDialog
    ref="dialog"
    title="Add Offcut"
    icon="fa-layer-plus"
    :showFooter="true"
    :scrollable="true"
    :showSubmit="!displayOffcutCreated"
    submitTitle="Create"
    :submitting="submitting"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" />
    <FormGroup v-bind:form="form" :labelColumnSize="3" v-if="!loading">
      <div v-if="!displayOffcutCreated">
        <ContentTitle>Offcut Details</ContentTitle>
        <FormRow label="Stock">
          <FormStaticLabel>{{stockName}}</FormStaticLabel>
        </FormRow>
        <FormRow label="Height">
          <FormInputText v-model="offcutData.height" placeholder="Height" field="height" />
        </FormRow>
        <FormRow label="Width">
          <FormInputText v-model="offcutData.width" placeholder="Width" field="width" />
        </FormRow>
        <FormRow label="Grain Direction" v-if="isStockUsingGrain">
          <FormSelect v-model="offcutData.grainDirection" field="grainDirection" :options="grainDirectionLookup" />
        </FormRow>

        <FormHorizontalRule />
        <ContentTitle>Offcut Location Details</ContentTitle>
        <ContentSubTitle>Location of the offcut piece</ContentSubTitle>

        <FormRow label="Inventory Bin">
          <FormInventoryBinSelect
            v-model="offcutData.inventoryBinId"
            placeholder="Inventory Bin"
            :accountLocationId="productionStation.accountLocationId" 
            :defaultLabelType="InventoryLabelTypes.defaultProductionStock"
          />
        </FormRow>
        <FormRow label="Comments">
          <FormInputTextArea v-model="offcutData.offcutComments" placeholder="Comments" field="offcutComments" />
        </FormRow>
      </div>

      <div v-if="displayOffcutCreated && glassLevel">
        <ContentTitle>Offcut Created</ContentTitle>

        <FormRow label="Offcut Details">
          <FormStaticLabel>
            {{glassLevel.barcode}}<br />
            {{glassLevel.stock.code}} - {{glassLevel.stock.name}}<br />
            {{glassLevel.height}} x {{glassLevel.width}}
          </FormStaticLabel>
        </FormRow>

        <FormButton class="btn-primary" @click="printOffcutLabel">Print Offcut Label</FormButton>

      </div>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import FormInventoryBinSelect from '@/modules/inventory/components/formInventoryBinSelect'
import ProductionStationMixin from '@/apps/glass-production-station/src/mixins/productionStation'

import { InventoryLabelTypes, StockGrainDirectionTypes, StockGrainDirectionTypeLookup } from '@/store/types'

export default {
  name: 'GlassAddOffcutDialog',
  mixins: [
    modalDialog,
    form,
    ProductionStationMixin
  ],
  components: {
    ModalDialog,
    FormInventoryBinSelect
  },
  props: {
    stockId: Number,
    stockName: String,
    productionStationId: Number
  },
  data() {
    return {
      form: {},
      offcutData: {
        stockId: 0,
        width: 0,
        height: 0,
        inventoryBinId: null,
        offcutComments: '',
        grainDirection: StockGrainDirectionTypes.vertical
      },

      stock: {},
      productionStation: {},
      grainDirectionLookup: StockGrainDirectionTypeLookup.filter(lookup => lookup.value != StockGrainDirectionTypes.none),

      loading: false,
      displayOffcutCreated: false,
      glassLevel: null,
      submitting: false
    }
  },
  created() {
    this.InventoryLabelTypes = InventoryLabelTypes
  },
  mounted() {
    this.requestData()
  },
  computed: {
    isStockUsingGrain() {
      return this.stock.isStockUsingGrain
    }    
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true
      this.form = this.clearFormResponse()

      this.offcutData.stockId = this.stockId

      this.$apiService.glassProductionStationService.createGlassOffcut(this.productionStationId, this.offcutData)
      .then(response => {
        this.glassLevel = response.data
        this.displayOffcutCreated = true
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    requestData() {
      this.loading = true

      Promise.all([
        this.$apiService.inventoryService.getStock(this.stockId),
        this.$apiService.productionService.getProductionStation(this.productionStationId)
      ])
      .then(results => {
        this.stock = results[0].data
        this.productionStation = results[1].data

        // If production station has a default offcut scan option available, default to that
        if(this.productionStation.offcutInventoryBinId) {
          this.offcutData.inventoryBinId = this.productionStation.offcutInventoryBinId
        }
      })
      .catch(err => {
        console.error(err)
        this.displayNetworkError(err, 'Error loading data')
      })
      .finally(() => {
        this.loading = false
      })
    },
    printOffcutLabel() {
      this.$apiService.glassProductionStationService.generatePrintOffcutLabelURL(this.productionStationId, this.glassLevel.id, { download: true, label: true })
      .then(response => {
        setTimeout(() => {
          this.displayPopupAlert('success', `Label Printed`, `Label printed for offcut`)
        }, 50)

        // Set to download
        window.location.href = response.data.url
      })
      .catch(err => {
        console.error(err)
        this.displayNetworkError(err, 'Print Error')
      })
    }
  }
}
</script>